<template>
  <div class="videoWrapper">
    <iframe
            :src="src"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
    ></iframe>
  </div>
</template>

<script>
  export default {
    props: [
      'src',
    ],
  }
</script>

<style lang="less" scoped>
  .videoWrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
  }
  .videoWrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
